// Simple i18n utility for Arabic and English

const translations = {
  ar: {
    dashboard: "لوحة التحكم",
    session: "ربط الهاتف",
    chat: "الرسائل",
    "auto-reply": "الرد الآلي",
    profile: "الملف الشخصي",
    "send-message": "إرسال رسالة",
    auth: "تسجيل الدخول",
    register: "تسجيل حساب جديد",
    connected:"متصل",
    "chat-statistics": "إحصائيات الرسائل",
    "auto-reply-list": "قائمة الردود الآلية",
    "session-status": "حالة الجلسة",
    "send-message-list": "قائمة الرسائل المرسلة",
    "dashboard-home": "الرئيسية",
    "not-found": "غير موجود",
    "settings": "الإعدادات",
    "users": "المستخدمون",
    "reports": "التقارير",
    "logout": "تسجيل الخروج",
    // Add more keys as needed for all UI labels
    "username": "اسم المستخدم",
    "password": "كلمة المرور",
    "login": "دخول",
    "trigger-text": "النص المستلم",
    "register-now": "تسجيل حساب جديد",
    "forgot-password": "نسيت كلمة المرور؟",
    "fullname": "الاسم الكامل",
    "email": "البريد الإلكتروني",
    "birthday": "تاريخ الميلاد",
    groups: "المجموعات",
    "phone": "رقم الهاتف",
    "confirm-password": "تأكيد كلمة المرور",
    "submit": "إرسال",
    "save": "حفظ",
    "cancel": "إلغاء",
    "search": "بحث",
    "actions": "العمليات",
    "edit": "تعديل",
    "delete": "حذف",
    "add": "إضافة",
    "back": "رجوع",
    "next": "التالي",
    "previous": "السابق",
    "home": "الرئيسية",
    "notifications": "الإشعارات",
    "success": "نجاح",
    "error": "خطأ",
    "loading": "جاري التحميل...",
    "no-data": "لا توجد بيانات",
    "welcome": "مرحباً",
    "logout-confirm": "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    "emoji-hint": "يمكنك استخدام الرموز التعبيرية مثل <span className='text-yellow-500'>:smile:</span> في الردود.",
    "client-management": "إدارة العملاء والمجموعات",
    "add-client-to-group": "إضافة عميل إلى مجموعة",
    "client-id": "معرف العميل",
    "add-member": "إضافة عضو",
    "group-name": "اسم المجموعة",
    "group-members": "أعضاء المجموعة",
    "create-group": "إنشاء مجموعة",
    "added-to-group": "تمت إضافته إلى المجموعة (تجريبي)",
    "group-created": "تم إنشاء المجموعة (تجريبي)",
    "remove": "حذف",
    "trigger-placeholder": "مثال: مرحبا",
    "reply-placeholder": "مثال: أهلاً بك!",
    "client": "العميل",
    "groups-list": "قائمة المجموعات",
    "send-message-to-group": "إرسال رسالة إلى المجموعة",
    "type-message": "اكتب الرسالة هنا...",
    "message-sent-to-group": "تم إرسال الرسالة إلى المجموعة",
    "message-required": "يجب إدخال رسالة",
    "whatsapp_api_title": "حلول WhatsApp API للأعمال",
    "whatsapp_api_subtitle": "اربط نظامك مع واتساب بسهولة، أرسل واستقبل الرسائل، أتمتة الردود، إدارة العملاء والمجموعات والمزيد!",
    "get_started": "ابدأ الآن",
    "features": "المميزات",
    "auto_reply": "الرد الآلي",
    "auto_reply_desc": "أتمتة الردود على رسائل العملاء وتوفير الوقت والجهد.",
    "dashboard_desc": "إحصائيات وتقارير مفصلة حول الرسائل والعملاء والمجموعات.",
    "easy_integration": "تكامل سهل",
    "easy_integration_desc": "تكامل سريع مع أنظمتك عبر API موثوق وسهل الاستخدام.",
    "how_it_works": "كيف يعمل النظام؟",
    "register_account": "سجل حسابك",
    "register_account_desc": "قم بإنشاء حساب جديد وابدأ في استخدام النظام.",
    "connect_whatsapp": "اربط واتساب",
    "connect_whatsapp_desc": "اربط رقم واتساب الخاص بك عبر رمز QR.",
    "start_sending": "ابدأ الإرسال",
    "start_sending_desc": "أرسل الرسائل، أدر العملاء والمجموعات، واستمتع بالأتمتة.",
    "ready_to_start": "جاهز للانطلاق؟",
    "cta_desc": "سجل الآن وابدأ في تطوير أعمالك مع حلول واتساب API المتقدمة.",
    payment: "الدفع",
    "payment-method": "طريقة الدفع",
    "payment-status": "حالة الدفع",
    "payment-history": "سجل المدفوعات",
    "payment-amount": "المبلغ",
    "payment-date": "تاريخ الدفع",
    "payment-desc":"قم بإجراء المدفوعات بسهولة وأمان.",
    "payment-success": "تمت عملية الدفع بنجاح",
    "payment-failed": "فشلت عملية الدفع",

  },
  en: {
    dashboard: "Dashboard",
    session: "Session",
    chat: "Chats",
    "auto-reply": "Auto Reply",
    profile: "Profile",
    "send-message": "Send Message",
    auth: "Login",
    register: "Register",
    "chat-statistics": "Chat Statistics",
    "auto-reply-list": "Auto Reply List",
    "session-status": "Session Status",
    "send-message-list": "Sent Messages",
    "dashboard-home": "Home",
    "not-found": "Not Found",
    "settings": "Settings",
    "users": "Users",
    "reports": "Reports",
    "logout": "Logout",
    // Add more keys as needed for all UI labels
    "username": "Username",
    "password": "Password",
    "login": "Login",
    "register-now": "Register Now",
    "forgot-password": "Forgot password?",
    "fullname": "Full Name",
    "email": "Email",
    "phone": "Phone",
    "confirm-password": "Confirm Password",
    "submit": "Submit",
    "save": "Save",
    "cancel": "Cancel",
    "search": "Search",
    "actions": "Actions",
    "edit": "Edit",
    "delete": "Delete",
    "add": "Add",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "home": "Home",
    "emoji-hint": "You can use emoji like <span className='text-yellow-500'>:smile:</span> in replies.",
    "trigger-text": "Trigger number",
    "notifications": "Notifications",
    "success": "Success",
    "error": "Error",
    "loading": "Loading...",
    "no-data": "No data",
    "welcome": "Welcome",
    "logout-confirm": "Are you sure you want to logout?",
    "client-management": "Client & Group Management",
    "add-client-to-group": "Add Client to Group",
    "client-id": "Client ID",
    "add-member": "Add Member",
    "group-name": "Group Name",
    "group-members": "Group Members",
    "create-group": "Create Group",
    "added-to-group": "added to group (demo)",
    "group-created": "Group created (demo)",
    "remove": "Remove",
    "groups-list": "Groups List",
    "send-message-to-group": "Send message to group",
    "type-message": "Type your message here...",
    "message-sent-to-group": "Message sent to group",
    "message-required": "Message is required",
    "whatsapp_api_title": "WhatsApp API Solutions for Business",
    "whatsapp_api_subtitle": "Easily connect your system to WhatsApp, send and receive messages, automate replies, manage clients and groups, and more!",
    "get_started": "Get Started",
    "features": "Features",
    "auto_reply": "Auto Reply",
    "auto_reply_desc": "Automate replies to customer messages and save time and effort.",
    "dashboard_desc": "Detailed statistics and reports about messages, clients, and groups.",
    "easy_integration": "Easy Integration",
    "easy_integration_desc": "Quick integration with your systems via a reliable, easy-to-use API.",
    "how_it_works": "How does it work?",
    "register_account": "Register your account",
    "register_account_desc": "Create a new account and start using the system.",
    "connect_whatsapp": "Connect WhatsApp",
    "connect_whatsapp_desc": "Connect your WhatsApp number via QR code.",
    "start_sending": "Start Sending",
    "start_sending_desc": "Send messages, manage clients and groups, and enjoy automation.",
    "ready_to_start": "Ready to start?",
    "cta_desc": "Register now and start growing your business with advanced WhatsApp API solutions."
  }
};

// Get current language from localStorage or default to Arabic
export function getLang() {
  return localStorage.getItem("lang") || "ar";
}

// Translate a key
export function t(key) {
  const lang = getLang();
  return translations[lang][key] || key;
}

// Helper for direction (rtl/ltr)
export function getDir() {
  const lang = getLang();
  return lang === "ar" ? "rtl" : "ltr";
}

// Optionally, export the translations object for advanced use
export default translations;
